import { z } from 'zod';

import { baseObjectSchema, baseSchema } from '../baseSchemas';

export const dcWarehouseSchema = baseObjectSchema.extend({
  warehouseId: z.string(),
  representativeId: z.string(),
  warehouseRemotedCode: z.string(),
  warehouse: baseSchema.optional(),
});

export const getDCWarehousesResponseSchema = z.object({
  data: z.array(dcWarehouseSchema),
  count: z.number(),
});

export type GetDCWarehousesResponse = z.infer<typeof getDCWarehousesResponseSchema>;
